module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-star3.3dc9b7a2.png";